import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton, Center, Text } from './Toggle.styled';

/**
 * A switch that can be turned off entirely: a disabled one still shows where it
 * stands but does not answer a click, and `title` is where the reason for that
 * goes so hovering it explains itself.
 */
const Toggle = ({ on, onClick, custom, disabled, title }) => (
  <Center $disabled={disabled} title={title} onClick={disabled ? undefined : onClick}>
    <ToggleButton on={on} disabled={disabled} type="button" />
    {custom ? (
      <Text>{on ? custom[0] : custom[1]}</Text>
    ) : (
      <Text>{on ? 'enabled' : 'disabled'}</Text>
    )}
  </Center>
);

Toggle.propTypes = {
  on: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  custom: PropTypes.shape([]).isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

Toggle.defaultProps = {
  on: false,
  disabled: false,
  title: undefined,
};

export default Toggle;
